import React from 'react';

function Support() {
  return (
    <section className="page-content">
      <div className="container">
        <h1 className="page-title">ForTuber Service Support</h1>
        <div className="page-body">
          <p>ForTuber (hereinafter referred to as "the Company") strives to respond to your inquiries promptly and accurately.</p>

          <div className="contact-box">
            <div className="contact-item">
              <div className="contact-label">Email</div>
              <div className="contact-value">
                <a href="mailto:cddchingudeul@gmail.com">cddchingudeul@gmail.com</a>
              </div>
            </div>
          </div>

          <h2>Guidelines for Inquiries</h2>
          <p>When making an inquiry, please provide the following information so we can respond more quickly and accurately.</p>
          <ul>
            <li>Detailed description of your inquiry</li>
            <li>When and under what circumstances the issue occurred</li>
            <li>Device information (Android/iOS, device model)</li>
            <li>App version information</li>
          </ul>

          <p>We strive to respond within 1-2 business days, and responses may be delayed on weekends and holidays.</p>
        </div>
      </div>
    </section>
  );
}

export default Support;
